import styled, { css } from 'styled-components';
import { StyledCheckboxLabel } from '../Checkbox/Checkbox.styles';
import { getTypographyIntent, typographyWeights } from '../Typography/Typography.styles';
import { colors } from '../_styles/colors';
import { spacing } from '../_styles/spacing';
export var StyledRequiredMark = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledRequiredMark",
  componentId: "core-12_20_2__sc-bja1ql-0"
})(["color:", ";", ""], colors.red50, function (_ref) {
  var $showLabel = _ref.$showLabel;
  if ($showLabel) {
    return;
  }
  return css(["", " font-weight:", ";"], getTypographyIntent('body'), typographyWeights.semibold);
});
export var StyledRequiredContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledRequiredContainer",
  componentId: "core-12_20_2__sc-bja1ql-1"
})(["", " ", " > &{margin-left:", "px;}"], getTypographyIntent('small'), StyledCheckboxLabel, spacing.xs);
export var StyledRequiredText = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledRequiredText",
  componentId: "core-12_20_2__sc-bja1ql-2"
})(["font-style:italic;color:", ";margin-left:4px;"], colors.gray45);
//# sourceMappingURL=Required.styles.js.map